// The sweep's last row: `.focus-row` caps its delay at row 12 (transitions.scss), so the foot lands last, as one block.
const FOCUS_SWEEP_LAST_ROW = 12

export { FOCUS_SWEEP_LAST_ROW }
